module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099TMMZX7.dbc4c092.jpg";